import React from 'react';

export const getCreditCardIcon = (url, className = 'credit-card-item-icon') => {
	return (
		<div className={className}>
			<img src={url}/>
		</div>
	);
};